import { BrowserRouter } from 'react-router-dom';
import Route from './Routes';
import './assets/scss/themes.scss';

function App() {
  return (
    // <BrowserRouter>
    <>
      <Route />
    </>
  );
}

export default App;
